import ReactModal from 'react-modal';
import { useEffect, useState } from 'react';
import { modalStyle } from '../../../../../../../utils/modal';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import { NumericFormat } from 'react-number-format';

function RewardSettingsModal({ settingsModal, closeModal, rewardData, setReward }) {
  const [value, setValue] = useState(rewardData[settingsModal?.key]);

  useEffect(() => {
    if (rewardData && settingsModal) {
      setValue(rewardData[settingsModal?.key]);
    }
  }, [rewardData, settingsModal]);

  const handleUpdate = () => {
    setReward(prev => ({ ...prev, data: { ...prev.data, [settingsModal?.key]: value } }));
    closeModal();
  };

  return (
    <ReactModal
      isOpen={!!settingsModal}
      style={modalStyle({ width: '460px' })}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      onRequestClose={closeModal}
    >
      <h5>Update Setting:</h5>
      <div className="mt-4">
        <Form.Label>{settingsModal?.name}</Form.Label>
        {settingsModal?.type === 'INTEGER' && (
          <NumericFormat
            className="bo-input"
            customInput={Form.Control}
            value={value ?? ''}
            onValueChange={({ floatValue }) => setValue(floatValue)}
            allowNegative={false}
            decimalScale={0}
          />
        )}
        {settingsModal?.type === 'REAL' && (
          <NumericFormat
            className="bo-input"
            customInput={Form.Control}
            value={value ?? ''}
            onValueChange={({ floatValue }) => setValue(floatValue)}
            allowNegative={false}
          />
        )}
      </div>
      <Row>
        <Col className="mt-5 d-flex gap-3 justify-content-center">
          <Button
            className="bo-button"
            disabled={value === null || value === undefined}
            onClick={handleUpdate}
          >
            Update
          </Button>
          <Button className="bo-button" onClick={closeModal}>
            Close
          </Button>
        </Col>
      </Row>
    </ReactModal>
  );
}

export default RewardSettingsModal;
